module.exports = __webpack_public_path__ + "static/media/ashish.948b7127.png";